import { useMemo } from 'react';
import API from '../../../../Utils/api';
import useAsync from '../../../../Hooks/useAsync';
import Card from '../../../../Components/Dashboard/Card';
import { CardEmpty, CardError, CardLoading } from '../../../../Components/Dashboard/CardState';
import { formatKm } from '../../../../Utils/format/pace';
import { lastFourWeeks } from './rangeLast4Weeks';
import HBarList from './HBarList';

const TITLE = 'Swimming styles';
const LABEL = {
    freestyle: 'Freestyle',
    backStroke: 'Backstroke',
    breastStroke: 'Breaststroke',
    butterfly: 'Butterfly',
    individualMedley: 'Individual Medley'
};

const SwimmingStylesCard = ({ athleteId, now: nowProp }) => {
    const now = useMemo(() => nowProp || new Date(), [nowProp]);
    const { status, data, error, reload } = useAsync(
        () => API.getSwimmingStylesStats(athleteId, lastFourWeeks(now)).then(res => res.data),
        [athleteId]
    );
    const total = (data || []).reduce((a, r) => a + r.distance, 0);

    let body;
    if (status === 'loading' && !data) body = <CardLoading label={TITLE} />;
    else if (status === 'error') body = <CardError label={TITLE} status={error?.response?.status} onRetry={reload} />;
    else if (!total) body = <CardEmpty>No swimming distance in the last 4 weeks.</CardEmpty>;
    else
        body = (
            <HBarList
                rows={data.map(r => ({
                    key: r.style,
                    label: LABEL[r.style] || r.style,
                    value: r.distance,
                    text: `${formatKm(r.distance)} km · ${r.percentage}%`
                }))}
            />
        );

    return (
        <Card id="ss" module="athlete-styles" title={TITLE} sub="distance, last 4 weeks" busy={status === 'loading'}>
            {body}
        </Card>
    );
};

export default SwimmingStylesCard;
